import { User } from 'oidc-client-ts';
import { getConfigValue } from '../../lib/public-env/get-config-value';
import type { MiddlewareFactory } from '../../middlewares/types';
import type { AuthProvider } from './types';

const createOpenIdAuthenticationMiddleware = (): MiddlewareFactory => {
  return (next) => {
    return (req, event) => next(req, event);
  };
};

const ELECTRON_ACCESS_TOKEN_KEY = 'terra.electron.access_token';

const getOpenIdSessionToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (window.electronAPI?.auth) {
    const token = window.sessionStorage.getItem(ELECTRON_ACCESS_TOKEN_KEY);
    return token ?? null;
  }

  const cognitoDomain = getConfigValue('NEXT_PUBLIC_OIDC_COGNITO_DOMAIN') || '';
  const issuerUrl = getConfigValue('NEXT_PUBLIC_OIDC_ISSUER_URL') || '';
  const authority = cognitoDomain || issuerUrl;
  const clientId = getConfigValue('NEXT_PUBLIC_OIDC_CLIENT_ID');

  if (!authority || !clientId) {
    return null;
  }

  const key = `oidc.user:${authority}:${clientId}`;
  const oidcStorage = window.localStorage.getItem(key);

  if (!oidcStorage) {
    return null;
  }

  try {
    const user = User.fromStorageString(oidcStorage);
    return user.access_token ?? null;
  } catch {
    return null;
  }
};

export const openIdAuthProvider: AuthProvider = {
  type: 'openid',
  createAuthenticationMiddleware: createOpenIdAuthenticationMiddleware,
  getSessionToken: getOpenIdSessionToken,
};
